import { cn } from '@discover-lib/utils';

export type RestaurantCardContainerProps = React.ComponentPropsWithoutRef<'div'>;

export default function RestaurantCardContainer({
  className,
  ...props
}: RestaurantCardContainerProps) {
  return (
    <div
      className={cn(
        'pointer-events-auto relative flex flex-col',
        'w-full max-w-[calc(1192px*0.75)]', // same max width as on the list view (75% of the "container" size)
        'bg-white shadow-2xl shadow-black',
        'rounded-t-lg sm:rounded-b-lg',
        className
      )}
      {...props}
    />
  );
}
